var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-grid__item m-grid__item--fluid m-wrapper" },
    [
      _c("div", { staticClass: "m-subheader" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "mr-auto" }, [
            _c(
              "h3",
              {
                staticClass: "m-subheader__title m-subheader__title--separator"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("titleize")(
                        _vm._f("translate")("user_administration")
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("ul", {
              staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline"
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-content" },
        [
          _c(
            "div",
            { staticClass: "m-portlet m-portlet--tab" },
            [
              _c("div", { staticClass: "m-portlet__head" }, [
                _c("div", { staticClass: "m-portlet__head-caption" }, [
                  _c(
                    "div",
                    { staticClass: "m-form m-form--label-align-right" },
                    [
                      _c("div", { staticClass: "m-portlet__head-title" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("h3", { staticClass: "m-portlet__head-text" }, [
                          _vm._v(_vm._s(_vm._f("capitalize")("profiles")))
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-portlet__head-tools" }, [
                  _vm.validPermission("create", "profile")
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success m-btn m-btn--icon",
                          attrs: {
                            id: "btn-newprofile",
                            "data-toggle": "modal",
                            "data-target": "#profile-modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.updateModalStatus(true)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "fa fa-plus-circle" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("capitalize")("create_profile"))
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("router-view")
            ],
            1
          ),
          _vm._v(" "),
          _c("s-new-profile")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon m--hide" }, [
      _c("i", {})
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26b14e12", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b14e12","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/Profiles.vue
// module id = 732
// module chunks = 0 1 133